import React from "react";

// API functions for task management
const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';


/**
 * Add a new task
 * @param {Object} userDetails - Task data
 * @returns {Promise<Object>} - API response
 */
export const sendPaymentReminderEmail = async (userDetails) => {
    try {
        const response = await fetch(`${API_URL}/api/Payment/send-payment-reminder`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                email: userDetails.email,
                tenantName: userDetails.name,
                apartmentNumber: userDetails.apartmentNumber,
                buildingNumber: '', // Add if you have building number
                unpaidMonths: userDetails.unpaidMonths || [],
                monthsUnpaidCount: userDetails.monthsUnpaidCount || 0,
                estimatedAmount: (userDetails.monthsUnpaidCount || 0) * 500 // 500 NIS per month estimate
            })
        });

        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
};

/**
 * Send bank transfer notification to management
 * @param {Object} transferDetails - Bank transfer details
 * @returns {Promise<Object>} - API response
 */
export const sendBankTransferNotification = async (transferDetails) => {
    try {
        const response = await fetch(`${API_URL}/api/Payment/notify-bank-transfer`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                tenantName: transferDetails.tenantName,
                tenantEmail: transferDetails.tenantEmail,
                apartmentNumber: transferDetails.apartmentNumber,
                 buildingNumber: transferDetails.apartmentNumber,
                // Send separate address components as expected by backend
                city: transferDetails.city || '',
                address: transferDetails.address || '',
                addressNumber: transferDetails.addressNumber || '',
                amount: transferDetails.amount,
                subscriptionDetails: transferDetails.subscriptionDetails || ''
            })
        });

        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
};